export default {
	title: '设备图片',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		imageFormatError: '只能上传 JPG/PNG 格式的图片!',
		imageSizeError: '图片大小不能超过 10MB!',
		uploadSuccess: '图片上传成功',
		uploadError: '图片上传失败',
		addSensorSuccess: '成功添加 {count} 个测点',
		updateSensorSuccess: '成功更新 {count} 个测点',
		noValidSensor: '请至少填写一个完整的测点信息',
		duplicateSensorName: '以下测点名称已存在：{names}'
	},
	form: {
		deviceTypeId: '设备类型',
		placeholder: {
			deviceTypeId: '请选择设备类型'
		}
	},
	table: {
		id: 'ID',
		name: '展示方案',
		deviceTypeId: '设备类型',
		sensorNumber: '测点数量',
		filePath: '设备图'
	},
	widgetForm: {
		deviceTypeId: '设备类型',
		deviceImage: '设备图片',
		gridLayout: '格栅布局',
		placeholder: {
			deviceTypeId: '请选择设备类型'
		}
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定',
		batchAddSensor: '批量添加测点'
	},
	labels: {
		solutionName: '方案名称',
		deviceType: '设备类型',
		deviceImage: '设备图片',
		isDefault: '是否默认',
		yes: '是',
		no: '否',
		sensorName: '测点名称',
		partName: '部位名称',
		serialNumber: '序号',
		addSensor: '新增点位',
		addSensorRow: '新增测点',
		operation: '操作'
	}
}
